import { Grid, Space, Table } from "../components/Layout";
import { Title, Texts, Media, ScrollTop } from "../components/Object";
import { NewsList, Pagination } from "../components/Post";
import { Head } from "../components/Project";
import { useParams } from "react-router-dom";

const News = () => {
  
  const parms = useParams();
  
  const args = {
    page: parms.id ? parms.id : 1,
    type: 'posts',
    perPage: 12
  }

  return (
    <>
      <Head slug="news" type="noimage"></Head>
      <div className="l-row">
          <NewsList perPage={args.perPage} page={args.page}></NewsList>
          <Pagination page={args.page} postType={args.type} perPage={args.perPage}></Pagination>
      </div>
      <ScrollTop></ScrollTop>
    </>
  );
};

export default News;